module.exports = __webpack_public_path__ + "img/sealImg3.dedb1e58.png";